import { useId, useRef } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export const AccessibleModal = ({ children, onClose, title = "Submission details", testId, width = 960 }) => {
  const id = useId().replace(/:/g, "");
  const trigger = useRef(document.activeElement);
  return <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
    <DialogContent onCloseAutoFocus={event => { event.preventDefault(); trigger.current?.focus?.(); }} data-testid={testId || `modal-${id}`} aria-describedby={undefined} className="audit-modal" style={{ width: `min(${width}px, calc(100vw - 24px))`, maxWidth: "calc(100vw - 24px)", maxHeight: "90dvh", overflowY: "auto", background: "var(--color-bg-hemocyanin)", border: "1px solid var(--hairline)" }}>
      <DialogTitle className="sr-only">{title}</DialogTitle>
      {children}
    </DialogContent>
  </Dialog>;
};